import React, { useState } from 'react';
import axios from 'axios';
import '../../styles/components/admin/createUser.css';

function CreateUser() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    role: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const validateForm = () => {
    const { email, password, role } = formData;
    
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError('Please enter a valid email');
      return false;
    }
    
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return false;
    }
    
    if (!/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
      setError('Password must contain an uppercase letter and a number');
      return false;
    }

    if (!role) {
      setError('Please select a role');
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!validateForm()) return;

    try {
      const response = await axios.post(
        'https://n8n.iniai.cloud/webhook/create-user',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_CREATE_USER_API_KEY
          }
        }
      );

      if (response.data.status === 'error') {
        setError(response.data.message);
      } else {
        setSuccess('User created successfully');
        setFormData({ email: '', password: '', role: '' });
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create user');
    }
  };

  return (
    <div className="create-user-container">
      <form onSubmit={handleSubmit} className="create-user-form">
        <h2>Create New User</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={formData.password}
            onChange={(e) => setFormData({...formData, password: e.target.value})}
            required
          />
          <small>Must be 8+ characters with uppercase letter and number</small>
        </div>

        <div className="form-group">
          <label htmlFor="role">Role:</label>
          <select
            id="role"
            value={formData.role}
            onChange={(e) => setFormData({...formData, role: e.target.value})}
            required
          >
            <option value="">Select Role</option>
            <option value="ini-uk">Initiative UK</option>
            <option value="volvo">Volvo</option>
            <option value="media-brands">Media Brands</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <button type="submit">Create User</button>
      </form>
    </div>
  );
}

export default CreateUser;